import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { Import, ImportCriteria, ImportDto, importCriteriaToDto, importFromDto } from '../models/import.model'
import { BaseService } from './base.service'

@Injectable({
    providedIn: 'root'
})
export class ImportService extends BaseService {
    get uri(): string {
        return `${this.baseUri}/Import`
    }

    constructor(readonly http: HttpClient) {
        super(http)
    }

    getLatest(): Observable<Import> {
        const uri = `${this.uri}/latest`

        return this.$http.get<ImportDto>(uri).pipe(map(importFromDto))
    }

    async triggerJiraBackfill(criteria: ImportCriteria): Promise<void> {
        const uri = `${this.uri}/jira-backfill`

        return this.$http
            .post<void>(uri, importCriteriaToDto(criteria), { observe: 'response' })
            .pipe(
                map(() => undefined),
                catchError((err) => this.handleError(err))
            )
            .toPromise()
    }
}
